import React, { Component } from 'react';
import Chart from "react-apexcharts";

class Graph extends Component {
  constructor(props) {
    super(props);

    this.state = {
      estimates: this.props.estimates,
      seriesQuarterly: [{
        name: 'Organization',
        data: [31, 40, 47, 40, 45, 75, 81]
      }],
      seriesMonth: [{
        name: 'Organization',
        data: [31, 40, 47, 40, 45, 75, 81]
      }],
      seriesYear: [{
        name: 'Organization',
        data: [31, 40, 47, 40, 45, 75, 81]
      }],
      optionsQuarterly: {
        chart: {
          height: 350,
          type: 'area'
        },
        title: {
          text: this.props.title,
          align: 'left'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          categories: ['05/05', '05/06', '05/07', '05/08', '05/09', '05/10', '05/11'],
        },
      },
      optionsMonth: {
        chart: {
          height: 350,
          type: 'area'
        },
        title: {
          text: this.props.title,
          align: 'left'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          categories: ['05/05', '05/06', '05/07', '05/08', '05/09', '05/10', '05/11'],
        },
      },
      optionsYear: {
        chart: {
          height: 350,
          type: 'area'
        },
        title: {
          text: this.props.title,
          align: 'left'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          categories: ['05/05', '05/06', '05/07', '05/08', '05/09', '05/10', '05/11'],
        },
      },
    };
  }
  quarterlyGraph = () => {
    let dataY = [],
      dataX = [],
      newdataY = [],
      newdataX = [],
      data = this.state.estimates,
      subtotal = 0,
      quarterMonthNew = "",
      count = 0;
    for (let i = 0; data.length > i; i++) {
      let total = data[i]['total'];
      const date = data[i]['date'];
      let quarterMonth = 0;
      if (!total) {
        total = 1100000;
      }
      const month = date.split('/')[1];
      const years = date.split('/')[2];
      if (month <= 3) {
        quarterMonth = 3;
      } else if (month > 3 && month <= 6) {
        quarterMonth = 6;
      } else if (month > 6 && month < 9) {
        quarterMonth = 9;
      } else if (month > 9 && month <= 12) {
        quarterMonth = 12;
      }
      if (i === 0) {
        quarterMonthNew = quarterMonth;
      }
      if (quarterMonthNew !== quarterMonth) {
        quarterMonthNew = quarterMonth;
        dataY.unshift(subtotal);
        const date = data[i - 1]['date'];
        const year = date.split('/')[2];
        count = count + 1;
        dataX.unshift(year);
        subtotal = total;
      } else {
        subtotal = subtotal + total;
      }
      if (i === data.length - 1) {
        dataY.unshift(subtotal);
        count = count + 1;
        dataX.unshift(years);
      }
    }
    for (let k = 0; dataX.length > k; k++) {
      newdataX.push("Q" + (k + 1) + " " + dataX[k]);
      newdataY.push(dataY[k]);
    }
    this.setState({
      seriesQuarterly: [
        {
          data: newdataY
        }
      ],
      optionsQuarterly:
      {
        xaxis: {
          categories: newdataX
        }

      }

    }
    );
  }
  monthGraph = () => {
    let dataY = [],
      dataX = [],
      data = this.state.estimates,
      subtotal = 0,
      monthNew = "";
    for (let i = 0; data.length > i; i++) {
      let total = data[i]['total'];
      const date = data[i]['date'];
      if (!total) {
        total = 1100000;
      }
      const month = date.split('/')[1];
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const monthName = months[month - 1];
      const year = date.split('/')[2];
      if (i === 0) {
        monthNew = month;
      }
      if (monthNew !== month) {
        monthNew = month;
        dataY.unshift(subtotal);
        const date = data[i - 1]['date'];
        const mon = date.split('/')[1];
        const y = date.split('/')[2]
        dataX.unshift(months[mon - 1] + " " + y);
        subtotal = total;
      } else {
        subtotal = subtotal + total;
      }
      if (i === data.length - 1) {
        dataY.unshift(subtotal);
        dataX.unshift(monthName + " " + year);
      }

    }
    this.setState({
      seriesMonth: [
        {
          data: dataY
        }
      ],
      optionsMonth:
      {
        xaxis: {
          categories: dataX
        }

      }

    }
    );
  }
  yearGraph = () => {
    let dataY = [],
      dataX = [],
      data = this.state.estimates,
      subtotal = 0,
      yearNew = "";
    for (let i = 0; data.length > i; i++) {
      let total = data[i]['total'];
      const date = data[i]['date'];
      if (!total) {
        total = 1100000;
      }
      const year = date.split('/')[2];
      if (i === 0) {
        yearNew = year;
      }
      if (yearNew !== year) {
        yearNew = year;
        dataY.unshift(subtotal);
        const date = data[i - 1]['date'];
        const y = date.split('/')[2]
        dataX.unshift(y);
        subtotal = total;
      } else {
        subtotal = subtotal + total;
      }
      if (i === data.length - 1) {
        dataY.unshift(subtotal);
        dataX.unshift(year);
      }

    }
    this.setState({
      seriesYear: [
        {
          data: dataY
        }
      ],
      optionsYear:
      {
        xaxis: {
          categories: dataX
        }

      }

    }
    );
  }
  componentDidMount = () => {
    this.quarterlyGraph();
    this.monthGraph();
    this.yearGraph();

  }

  render() {

    return (

      <div id="chart">
        {this.props.graphType === 'quarterly' && (
          <Chart options={this.state.optionsQuarterly} series={this.state.seriesQuarterly} type={this.props.type} height={350} />
        )}
        {this.props.graphType === 'month' && (
          <Chart options={this.state.optionsMonth} series={this.state.seriesMonth} type={this.props.type} height={350} />
        )}
        {this.props.graphType === 'year' && (
          <Chart options={this.state.optionsYear} series={this.state.seriesYear} type={this.props.type} height={350} />
        )}
      </div>

    );
  }

}

export default Graph;